export const facilityBlackoutQueryKeys = {
  all: () => "facility-blackout"
};
